import { axiosInstance } from "./axiosInstance";

// Service untuk fitur AI Audit Tryout.
// Endpoint mengikuti pola Tryout.Service.jsx (axiosInstance + path relatif).
export const AIAuditTryoutService = {
  // Mulai audit AI untuk satu tryout.
  // POST /api/feature/membership/tryout/ai-audit/{tryout_id}
  // Expect: 202 Accepted.
  // Optional: confirm_reaudit=true untuk audit ulang (hapus hasil lama).
  startAudit: async (tryoutId, confirmReaudit = false) => {
    return await axiosInstance.post(
      `/api/feature/membership/tryout/ai-audit/${tryoutId}`,
      confirmReaudit ? { confirm_reaudit: true } : {}
    );
  },

  // Ambil hasil audit AI untuk satu tryout.
  // GET /api/feature/membership/tryout/ai-audit/{tryout_id}/results
  getAuditResults: async (tryoutId) => {
    return await axiosInstance.get(
      `/api/feature/membership/tryout/ai-audit/${tryoutId}/results`
    );
  },

  // Selesaikan satu hasil audit.
  // PATCH /api/feature/membership/tryout/ai-audit-results/{id}/solve
  // NOTE: baru dipakai di STEP 3, disiapkan di sini agar konsisten dengan service.
  solveAuditResult: async (id, payload) => {
    return await axiosInstance.patch(
      `/api/feature/membership/tryout/ai-audit-results/${id}/solve`,
      payload
    );
  },
};